<template>
  <div id="app">
    <router-view></router-view>
    <div class="navbars" v-show="url!='/login'">
        
        <ul class="clearfix" v-show="ifshowtab" @mouseover='showtab' @mouseleave="hidetab">
            <li id="five1" @click="changepage('index')" :class="currentpath=='index' ? 'now': ''" ><span>报表管理</span></li>
            <li id="five2" @click="changepage('peoplemanager')" :class="currentpath=='peoplemanager' ? 'now': ''" ><span>人员管理</span></li>
            <li id="five3" @click="changepage('carmanager')" :class="currentpath=='carmanager' ? 'now': ''" ><span>车辆管理</span></li>
            <li id="five4" @click="changepage('pzmanager')" :class="currentpath=='pzmanager' ? 'now': ''" ><span>排障管理</span></li>
            <li id="five5" @click="changepage('txmanager')" :class="currentpath=='txmanager' ? 'now': ''" ><span>提醒管理</span></li>
        </ul>

        <div class="sanjiao">
          <img src="./assets/images/index/upsanjiao.svg" @mouseover='showtab' >
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return {
      currentpath:'index',
      ifshowtab:false,
	  url:''
    }
  },
  created() {
	this.url = this.$route.path
  },
  methods:{
    changepage(path){
      this.currentpath=path;
	  this.url = path;
      this.$router.replace(path)
      this.ifshowtab=false
    },
    showtab(){
      this.ifshowtab=true
    },
    hidetab(){
      this.ifshowtab=false
    }
  },
  watch:{
	  '$route.path': function (newVal, oldVal) {
			this.url = newVal
	    }
  }
}
</script>

<style>
@import "./assets/css/style.css";
/* @import "./assets/css/map.css"; */
</style>
